import React, { useEffect } from 'react'

type GradientBannerProps = {
  seed?: string
}

const GradientBanner = ({ seed = 'no_seed' }: GradientBannerProps): JSX.Element => {
  const [color1, setColor1] = React.useState('rgba(0,0,0,0.0)')
  const [color2, setColor2] = React.useState('rgba(0,0,0,0.0)')

  useEffect(() => {
    sha256(seed).then((hash) => {
      setColor1(`hsl(${(hash[0] / 256) * 360}deg, ${100}%, ${3 * (hash[1] / 256 / 4) * 100}%)`)
      setColor2(`hsl(${(hash[2] / 256) * 360}deg, ${100}%, ${((3 * hash[3]) / 256 / 4) * 100}%)`)
    })
  }, [seed])

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        background: `linear-gradient(rgb(16,16,16, 0.5), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), linear-gradient(135deg, ${color1}, ${color2})`,
      }}
    ></div>
  )
}

async function sha256(message: string): Promise<number[]> {
  const bytes = new TextEncoder().encode(message)
  const hash = await crypto.subtle.digest('SHA-256', bytes)
  return Array.from(new Uint8Array(hash))
}

export default GradientBanner
